import { combineEpics } from 'redux-observable';
import InspectionsEpics from './inspections';
import InspectionDetailEpics from './inspection';
import AuthEpics from './auth'

export default combineEpics(
	InspectionsEpics,
	InspectionDetailEpics,
	AuthEpics
);



// WEBPACK FOOTER //
// ./src/redux/epics/index.js